import dayjs from 'dayjs';

/**
 * Formatadores de exibição (labels em português) para os campos de
 * configuração de uma CategoriaTorneio.
 *
 * Util puro: traduz valores brutos do domínio (enums / números) para texto
 * legível. Não depende de camadas superiores (componentes, services, context).
 */

const NAO_DEFINIDO = 'Não definido';

export const formatModeloDisputa = (modelo?: string | null): string => {
  const modelos: Record<string, string> = {
    ELIMINACAO_SIMPLES: 'Eliminação Simples',
    ELIMINACAO_DUPLA: 'Eliminação Dupla',
    GRUPOS_ELIMINACAO: 'Grupos + Eliminação',
    GRUPO_UNICO: 'Grupo Único',
    LIGA: 'Liga',
    SUICO: 'Suíço',
    REI_RAINHA: 'Rei/Rainha da Quadra',
    SUPER_8: 'Super 8',
  };
  return modelo ? modelos[modelo] || modelo : NAO_DEFINIDO;
};

export const formatTipoPontuacao = (tipo?: string | null): string => {
  const tipos: Record<string, string> = {
    SETSGAMES: 'Sets e Games',
    SETSPONTOS: 'Sets e Pontos',
  };
  return tipo ? tipos[tipo] || tipo : NAO_DEFINIDO;
};

export const formatGenero = (genero?: string | null): string => {
  const generos: Record<string, string> = {
    MASCULINO: 'Masculino',
    FEMININO: 'Feminino',
    MISTO: 'Misto',
    OUTRO: 'Outro',
  };
  return genero ? generos[genero] || genero : NAO_DEFINIDO;
};

/** numeroAtletas por equipe: 1 = Simples, 2 = Dupla. */
export const formatTipoCategoria = (numeroAtletas?: number | null): string => {
  if (numeroAtletas === 1) return 'Simples';
  if (numeroAtletas === 2) return 'Dupla';
  return numeroAtletas != null ? `${numeroAtletas} atletas` : NAO_DEFINIDO;
};

/** Mesmos rótulos do seletor "Número de Sets" da tela de edição. */
export const formatNumeroSets = (numeroSets?: number | null): string => {
  const labels: Record<number, string> = {
    1: '1 Set',
    2: '2 Sets + Super Tiebreak',
    3: '3 Sets',
    4: '4 Sets + Super Tiebreak',
    5: '5 Sets',
  };
  return numeroSets != null ? labels[numeroSets] || `${numeroSets} Sets` : NAO_DEFINIDO;
};

/**
 * configFilaEspera é tri-estado:
 * true = ativada, false = desativada, null/undefined = herda do torneio.
 */
export const formatConfigFilaEspera = (config?: boolean | null): string => {
  if (config === true) return 'Ativada';
  if (config === false) return 'Desativada';
  return 'Segue a configuração do torneio';
};

export const formatBooleanSimNao = (value?: boolean | null): string =>
  value ? 'Sim' : 'Não';

/** Data de exibição no formato DD/MM/YYYY; 'Não definido' quando vazia/inválida. */
export const formatDataCategoria = (value?: string | null): string =>
  value ? (dayjs(value).isValid() ? dayjs(value).format('DD/MM/YYYY') : NAO_DEFINIDO) : NAO_DEFINIDO;
